import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Landing from "@/pages/Landing"; // eager — landing is the primary entry route

// Lazy-loaded routes — each becomes its own chunk so the initial bundle stays lean.
const Shop = lazy(() => import("@/pages/Shop"));
const DropDetail = lazy(() => import("@/pages/DropDetail"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const Checkout = lazy(() => import("@/pages/Checkout"));
const OrderConfirmation = lazy(() => import("@/pages/OrderConfirmation"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));

function StorefrontLayout() {
  const loc = useLocation();
  React.useEffect(() => {
    // scroll to top on route change; but let hash anchors work
    if (!loc.hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [loc.pathname, loc.hash]);
  return (
    <>
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
}

function AdminLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-[60vh] flex items-center justify-center font-mono text-[10px] tracking-widest uppercase text-bone/50">Loading…</div>}>
              <Routes>
                <Route element={<StorefrontLayout />}>
                  <Route path="/" element={<Landing />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/drops/:dropId" element={<DropDetail />} />
                  <Route path="/product/:productId" element={<ProductDetail />} />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route path="/order/:orderId" element={<OrderConfirmation />} />
                </Route>
                <Route element={<AdminLayout />}>
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                </Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
